// quick-view 自体は Dawn の quick-add.js / product-form.js に委ね、ここは追従バーだけを担当する（#98）

// cart-drawer を消すと product-form.js が this.cart 不在で /cart へ遷移するため、
// open() だけ潰して renderContents によるカート更新は残す
// 対象別に exhibition-b2b-jp 等へ分岐するため前方一致で拾う（#333）
if (document.body.dataset.templateSuffix?.startsWith('exhibition')) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) cartDrawer.open = () => {};
}

if (!customElements.get('exhibition-cart-bar')) {
  customElements.define(
    'exhibition-cart-bar',
    class ExhibitionCartBar extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.open = false;
        this.addEventListener('click', this.onClick.bind(this));
      }

      connectedCallback() {
        // 他 UI（ヘッダー個数バッジ等）と同じ cart-update で追従する
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'exhibition-cart-bar') return;
          this.refresh();
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      onClick(event) {
        const toggle = event.target.closest('.c_js-cart-bar-toggle');
        if (toggle) {
          this.setOpen(!this.open);
          return;
        }

        const qtyButton = event.target.closest('.c_js-cart-bar-qty');
        if (qtyButton) {
          this.changeLine(qtyButton.dataset.line, parseInt(qtyButton.dataset.quantity, 10));
          return;
        }

        const removeButton = event.target.closest('.c_js-cart-bar-remove');
        if (removeButton) {
          this.changeLine(removeButton.dataset.line, 0);
        }
      }

      setOpen(open) {
        this.open = open;
        const panel = this.querySelector('#ExhibitionCartBarPanel');
        const toggle = this.querySelector('.c_js-cart-bar-toggle');
        if (panel) panel.hidden = !open;
        if (toggle) toggle.setAttribute('aria-expanded', open);
        this.classList.toggle('is-open', open);
      }

      changeLine(line, quantity) {
        this.setBusy(true);
        const config = fetchConfig('json');
        config.body = JSON.stringify({
          line,
          quantity,
          sections: [this.sectionId],
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, config)
          .then((response) => response.json())
          .then((cart) => {
            if (cart.sections && cart.sections[this.sectionId]) {
              this.renderFromHTML(cart.sections[this.sectionId]);
            }
            // ヘッダー等の Dawn カート UI も更新させる
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'exhibition-cart-bar',
              cartData: cart,
            });
          })
          .catch((error) => console.error(error))
          .finally(() => this.setBusy(false));
      }

      refresh() {
        fetch(`${window.location.pathname}?section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((text) => this.renderFromHTML(text))
          .catch((error) => console.error(error));
      }

      renderFromHTML(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector('exhibition-cart-bar');
        if (!fresh) return;

        this.innerHTML = fresh.innerHTML;
        this.classList.toggle('is-active', fresh.classList.contains('is-active'));
        // 再描画後も展開状態を維持する
        this.setOpen(this.open && this.classList.contains('is-active'));
      }

      setBusy(busy) {
        // toggleAttribute は aria-busy="" になり CSS の [aria-busy='true'] に一致しない（#341）
        if (busy) this.setAttribute('aria-busy', 'true');
        else this.removeAttribute('aria-busy');
      }
    },
  );
}

if (!customElements.get('exhibition-tabs')) {
  customElements.define(
    'exhibition-tabs',
    class ExhibitionTabs extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
      }

      get tabs() {
        return Array.from(this.querySelectorAll('[role="tab"]'));
      }

      onClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(tab);
      }

      onKeydown(event) {
        const tabs = this.tabs;
        const current = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        if (current < 0) return;

        let next = null;
        if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;

        event.preventDefault();
        this.select(tabs[next]);
      }

      select(tab) {
        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.classList.toggle('is-active', selected);
          if (selected) item.removeAttribute('tabindex');
          else item.setAttribute('tabindex', '-1');

          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });

        // Safari はクリックしてもボタンにフォーカスを与えない。移しておかないと直後の矢印キーが keydown に届かない
        tab.focus();
      }
    },
  );
}

document.addEventListener('click', (event) => {
  if (!event.target || typeof event.target.closest !== 'function') return;

  const opener = event.target.closest('modal-opener[data-modal]');
  if (!opener) return;

  const modal = document.querySelector(opener.dataset.modal);
  const content = modal && modal.querySelector('.quick-add-modal__content-info');
  if (!content) return;

  const observer = new MutationObserver(() => {
    const accordions = content.querySelectorAll('details');
    if (accordions.length === 0) return;

    accordions.forEach((accordion) => accordion.setAttribute('open', ''));
    observer.disconnect();
  });

  observer.observe(content, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 10000);
});
